module.exports = __webpack_public_path__ + "static/media/bg11.720b7d88.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/minibg/bg11.jpg
// module id = 593
// module chunks = 0